// 农事日历
<template>
  <el-card class="card-main">
    <el-form class="global-form2" :model="planInfo" ref="planInfo" :rules="rules" label-width="120px">
      <el-form-item label="项目名称" prop="projectId">
        <el-select :disabled="this.planId" v-model="planInfo.projectId" placeholder="请选择项目名称" filterable clearable
          @change="change">
          <el-option v-for="item in projectList" :key="item.projectId" :label="item.projectName"
            :value="item.projectId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划日期" prop="planStart">
        <el-date-picker :clearable="false" @change="changeDate" v-model="dateRange" type="daterange" range-separator="-"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions" start-placeholder="开始日期" end-placeholder="结束日期"
          :disabled="this.planId">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="作业任务" prop="taskList">
        <div v-if="unFinisedList.length > 0" class="tips">
          <img src="@/assets/img/icon_common_notice_yellow.png">&nbsp;存在未完成的计划作业任务，点击后可直添加
        </div>
        <div class="unfinished" v-for="(item, index) in unFinisedList" :key="index">
          <span>{{ item.taskNotes }}</span>
          <i class="el-icon-circle-plus-outline" @click="add(item.taskNotes, index)"></i>
        </div>
        <div class="task" v-for="(item, index) in planInfo.taskList" :key="index">
          <p>
            <span>任务{{ index + 1 }}</span>
            <i class="el-icon-close" @click="onClose(index)"></i>
          </p>
          <el-form-item :prop="'taskList.' + index + '.taskNotes'" :rules='rules.taskNotes'>
            <el-input type="textarea" :rows="3" maxlength="100" show-word-limit placeholder="请输入任务内容"
              v-model="item.taskNotes">
            </el-input>
          </el-form-item>
        </div>
        <el-button class="button" type="primary" icon="el-icon-plus" @click="onAdd">新增作业任务</el-button>
      </el-form-item>
      <el-form-item label="任务抄送" prop="userIds">
        <el-select v-model="planInfo.userIds" placeholder="请选择任务抄送人" multiple filterable clearable>
          <el-option v-for="(item, index) in userList" :label="item.userName" :value="item.userId"
            :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" :disabled="submitShow" @click="onSubmit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      dateRange: [],
      pickerOptions: {},
      planInfo: {
        projectId: '',
        planStart: '',
        planEnd: '',
        userIds: '',
        taskList: []
      },
      userList: [],
      unFinisedList: [],
      submitShow: false,
      rules: {
        projectId: [{ required: true, message: '请选择项目', trigger: 'change' }],
        planStart: [{ required: true, message: '请选择计划日期' }],
        userIds: [{ required: true, message: '请选择任务抄送人' }],
        taskList: [{ required: true, message: '请填写作业任务' }],
        taskNotes: [{ required: true, message: '请填写作业任务' }]
      }
    }
  },
  computed: {
    projectList () {
      return this.$store.state.projectList
    },
    planId () {
      return this.$route.params.planId
    }
  },
  created () {
    this.onAdd()
    if (this.planId) {
      this.getDetail()
    }
  },
  methods: {
    onAdd () {
      this.planInfo.taskList.push({
        taskNotes: ''
      })
    },
    onClose (index) {
      this.planInfo.taskList.splice(index, 1)
    },

    getDetail () {
      this.$axios.get(this.$apis.operationmanage.selectYhDailyPlanByPlanId, {
        planId: this.planId
      }).then(async res => {
        if (this.planId) {
          this.planInfo.projectId = res.projectId
          this.dateRange = [res.planStart, res.planEnd]
          await this.getProjectUserList()
          this.planInfo = res || {}
          this.planInfo.userIds = res.userIds.split(',')
          this.$refs.planInfo.clearValidate()
        }
      })
    },
    changeDate () {
      if (this.dateRange.length > 0) {
        this.planInfo.planStart = this.dateRange[0]
        this.planInfo.planEnd = this.dateRange[1]
      }
      this.$refs.planInfo.clearValidate('planStart')
    },
    change () {
      this.getProjectUserList()
      this.getLastPlan()
    },

    getLastPlan () {
      this.$axios.get(this.$apis.operationmanage.selectUpYhDailyPlanByProjectId, {
        projectId: this.planInfo.projectId
      }).then(res => {
        if (res) {
          if (res.planEnd) {
            this.unFinisedList = res.taskList.filter((t) => t.taskState === '0')
            this.dateRange = [this.$dayjs(res.planEnd).add(1, 'day').format('YYYY-MM-DD'), this.$dayjs(res.planEnd).add(8, 'day').format('YYYY-MM-DD')]
          }
          this.pickerOptions = {
            disabledDate: (time) => {
              const date = this.$dayjs(res.planEnd).add(1, 'day').format('YYYY/MM/DD')
              const current = this.$dayjs(date).valueOf()
              return time.getTime() < current
            }
          }
        } else {
          this.unFinisedList = []
          this.dateRange = [this.$dayjs().format('YYYY-MM-DD'), this.$dayjs().add(7, 'day').format('YYYY-MM-DD')]
          this.pickerOptions = {
            disabledDate: (time) => {
              const date = this.$dayjs().format('YYYY/MM/DD')
              const current = this.$dayjs(date).valueOf()
              return time.getTime() < current
            }
          }
        }
      })
    },

    add (item, index) {
      this.unFinisedList.splice(index, 1)
      if (!this.planInfo.taskList[this.planInfo.taskList.length - 1].taskNotes) {
        this.planInfo.taskList[this.planInfo.taskList.length - 1].taskNotes = item
        this.planInfo.taskList.push({
          taskNotes: ''
        })
      } else {
        this.planInfo.taskList.push({
          taskNotes: item
        })
      }
    },

    // 项目人员列表
    getProjectUserList () {
      this.$axios.get(this.$apis.project.selectYhProjectUserByList, {
        projectId: this.planInfo.projectId
      }).then(res => {
        this.userList = res || []
      })
    },

    onSubmit () {
      if (this.dateRange.length > 0) {
        this.planInfo.planStart = this.dateRange[0]
        this.planInfo.planEnd = this.dateRange[1]
      }
      this.$refs.planInfo.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const url = this.planId
            ? this.$apis.operationmanage.updateYhDailyPlan
            : this.$apis.operationmanage.insertYhDailyPlan
          const params = JSON.parse(JSON.stringify(this.planInfo))
          params.userIds = this.planInfo.userIds.join(',')
          params.userNames = this.planInfo.userIds.map((id) => {
            const obj = this.userList.find((o) => o.userId === id)
            return obj ? obj.userName : ''
          }).join(',')
          this.$axios.post(url, params).then((res) => {
            this.$message.success('保存成功')
            this.$router.back()
          }).catch(() => {
            this.submitShow = false
          })
        }
      })
    }
  }

}
</script>

<style lang='scss' scoped>
.task {
  width: 520px;
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #EBEBEB;
  padding: 6px 10px 10px;
  margin-bottom: 20px;

  p {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    padding-bottom: 6px;

    i {
      cursor: pointer;
    }
  }
}

.tips {
  display: flex;
  align-items: center;
  width: 520px;
  height: 32px;
  background: #FAFAFA;
  border-radius: 4px;
  border: 1px solid #EBEBEB;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #F5A623;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  padding-left: 10px;
  margin-bottom: 10px;
}

.unfinished {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 300px;
  background: rgba(255, 132, 18, 0.15);
  border-radius: 4px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  padding: 8px 10px;
  margin-bottom: 10px;

  i {
    cursor: pointer;
  }
}
</style>
